import * as React from "react";
import { Input, Button, Form } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { UserSelection } from "Components/Form/UserSelection";
import { I18N_NS } from "Config/i18n";
import { ifNumber } from "utils/inputValidation";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ProjectFilesSearchFormProps extends WithTranslation {
  initialData?: API_DocSearchReq;
  onSubmit: (values: API_DocSearchReq) => void;
  onCancel: () => void;
  loading: boolean;
}

export const ProjectFilesSearchForm = withTranslation([I18N_NS.PROJECT, I18N_NS.WORKFLOW])(
  observer(
    class extends React.Component<ProjectFilesSearchFormProps> {
      handleSubmit = (values) => {
        this.props.onSubmit(values);
      };

      render() {
        const { initialData, loading, t } = this.props;
        return (
          <Form onFinish={this.handleSubmit}>
            {/* {projectsDataStore.functions.includes('FULLTEXTSEARCH') && (  // DEV-2881
              <Form.Item>
                {getFieldDecorator('inAllTextFields', {
                  initialValue: initialData && initialData.inAllTextFields
                })(
                  <Input placeholder={t('Full-text search')} autoFocus={true} />
                )}
              </Form.Item>
            )} */}
            <Form.Item name="fileName" initialValue={initialData && initialData.fileName}>
              <Input placeholder={t(`Filename`)} data-testid="project-files-search-filename-input" />
            </Form.Item>
            <Form.Item name="index" initialValue={initialData && initialData.index}>
              <Input placeholder={t(`Index`)} />
            </Form.Item>
            <Form.Item name="ownerId" initialValue={initialData && initialData.ownerId}>
              <UserSelection allowClear={true} placeholder={t(`Owner`)} />
            </Form.Item>
            <Form.Item
              name="youngerThanDays"
              rules={[{ validator: ifNumber }]}
              initialValue={initialData && initialData.youngerThanDays}
            >
              <Input placeholder={t(`Younger than`)} suffix={t("Days")} />
            </Form.Item>
            {/* <Form.Item>
            {getFieldDecorator('unread', {
              initialValue: initialData && initialData.test
            })(
              <Checkbox>Unread/not yet ordered files</Checkbox>
            )}
          </Form.Item> */}
            <ButtonsRow justify="space-between">
              <Button onClick={this.props.onCancel} data-testid="project-files-search-back-button">
                <FontAwesomeIcon icon={"chevron-left"} style={{ marginRight: 5 }} fixedWidth={true} size="lg" />
                {t("Back")}
              </Button>
              <Button
                type="primary"
                loading={loading}
                htmlType="submit"
                data-testid="project-files-search-submit-button"
              >
                {t("Search")}
              </Button>
            </ButtonsRow>
          </Form>
        );
      }
    }
  )
);
